import { DictionaryValue } from '../models/classes/dictionary/dictionaryValue';
import { Dictionary } from '../models/classes/dictionary/dictionary';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DictionariesService {
    dictionariesListChanged = new Subject<Dictionary[]>();
    private baseUrl: string = environment.apiUrl + 'dictionaries';
    private dictionaries: Dictionary[];

    constructor(
        private http: HttpClient
    ) { }

    getList(): Observable<Dictionary[]> {
        return this.http.get<Dictionary[]>(this.baseUrl)
        .pipe(
          map(dictionaries => {
              this.dictionaries = dictionaries.map(c => Dictionary.fromObject(c));
              this.dictionaries.sort((a, b) => a.description.localeCompare(b.description));
              this.dictionariesListChanged.next([ ...this.dictionaries ]);
              return [ ...this.dictionaries ];
          })
      );
    }

    put(dictionary: Dictionary): Observable<Dictionary> {
      return this.http.put<Dictionary>(this.baseUrl, dictionary)
      .pipe(
          tap(editedDictionary => {
              // editedDictionary = Dictionary.fromObject(editedDictionary);
              this.dictionaries = this.dictionaries.map(c => c.id === editedDictionary.id ? editedDictionary : c);
              this.dictionariesListChanged.next([ ...this.dictionaries ]);
          })
      );
  }

  post(dictionary: Dictionary): Observable<Dictionary> {
      return this.http.post<Dictionary>(this.baseUrl, dictionary)
      .pipe(
          tap(createdDictionary => {
              // createdDictionary = Dictionary.fromObject(createdDictionary);
              this.dictionaries.push(createdDictionary);
              this.dictionariesListChanged.next([ ...this.dictionaries ]);
          })
      );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`)
    .pipe(
        tap(() => {
            this.dictionaries = this.dictionaries.filter(m => m.id !== id);
            this.dictionariesListChanged.next([ ...this.dictionaries ]);
        })
    );
}

}
